
interface VideoSummaryResult {
  keyPoints: string[];
  impressions: string[];
  overallRating: number;
  communicationScore: number;
  confidenceScore: number;
  enthusiasmScore: number;
  recommendationText: string;
}

// Mock AI video analysis function
// In a real implementation, this would call an AI service API
export const generateVideoSummary = async (videoUrl: string): Promise<VideoSummaryResult> => {
  console.log('Generating AI summary for video:', videoUrl);
  
  // This is a mock implementation
  // In a real app, you would send the videoUrl to a backend service
  // that would process the video and return an AI analysis
  
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // For demo purposes, generate a random but realistic-looking summary
  const communicationScore = Math.floor(Math.random() * 30) + 70; // 70-100
  const confidenceScore = Math.floor(Math.random() * 30) + 70; // 70-100
  const enthusiasmScore = Math.floor(Math.random() * 30) + 70; // 70-100
  const overallRating = Math.round((communicationScore + confidenceScore + enthusiasmScore) / 3);
  
  const keyPointOptions = [
    "Has 5+ years experience with React and TypeScript",
    "Led a team of 3-7 developers on multiple projects",
    "Worked on large-scale e-commerce applications",
    "Experienced with CI/CD pipelines and DevOps",
    "Strong understanding of state management",
    "Familiar with microservices architecture",
    "Experienced with Agile development processes",
    "Has worked with GraphQL and REST APIs",
    "Experience with cloud providers (AWS, Azure)",
    "Mentioned experience optimizing application performance",
    "Has experience with mobile app development",
    "Mentioned designing component libraries",
    "Has worked with international teams",
    "Experience with real-time applications",
    "Mentioned contributions to open-source projects",
    "Highlighted problem-solving skills"
  ];
  
  const impressionOptions = [
    "Communicated technical concepts clearly",
    "Showed enthusiasm when discussing past projects",
    "Appeared nervous at the beginning but became more confident",
    "Maintained good eye contact throughout the video",
    "Used technical jargon appropriately",
    "Spoke at an appropriate pace",
    "Demonstrated confidence in their abilities",
    "Organized thoughts in a coherent manner",
    "Highlighted specific achievements effectively",
    "Showed passion for technology and development",
    "Seemed genuine and authentic in their presentation",
    "Presented themselves professionally",
    "Provided specific examples from past experience",
    "Articulated career goals clearly",
    "Demonstrated good storytelling ability",
    "Showed a positive attitude"
  ];
  
  const recommendationOptions = [
    "Consider for interview - candidate demonstrates strong technical background and communication skills",
    "Recommended for technical interview - strong experience in required technologies",
    "Potential team fit - good communication and relevant experience",
    "Consider for junior position - enthusiastic but may need mentoring",
    "Strong potential - recommend proceeding to next stage",
    "Interview recommended - technical skills align with requirements",
    "Possible cultural fit - positive attitude and relevant skills",
    "Promising candidate - follow up with technical assessment",
    "Good communication skills - verify technical expertise in interview",
    "Consider for leadership role - demonstrated management experience",
    "Technical specialist - deep expertise in core technologies",
    "Recommend technical follow-up - verify specific skills"
  ];
  
  // Select random items from each array
  const getRandomItems = (arr: string[], count: number) => {
    const shuffled = [...arr].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  };
  
  return {
    keyPoints: getRandomItems(keyPointOptions, 4),
    impressions: getRandomItems(impressionOptions, 5),
    overallRating,
    communicationScore,
    confidenceScore,
    enthusiasmScore,
    recommendationText: recommendationOptions[Math.floor(Math.random() * recommendationOptions.length)]
  };
};
